<template>
    <div>

    </div>

</template>

<script>
    export default {
        name: "toast",
        data() {
            return {
                delay_time : 9000,
                toastCount: 0,
                string_err : 'IMC ERR',
                string_title : 'IMC_ERR TITLE',
                variant : 'success',
				position : "b-toaster-top-right"
            }
        },

        created () {
            EventBus.$on('new_order_in',order => {
                this.$notification.show('GetOrder NEW ORDER :' + order.order_code, {
                    body: 'ORDER_PROVIDER :'+ order.provider_in_txt
                }, {});
                console.log(order);
            });


            EventBus.$on('show_toast', e => {
                console.log(e);
                if(e !== undefined) {
                    this.string_err       = e.err;
                    this.string_title     = e.title;
                    if(e.type !== undefined) {
                        this.variant = e.type;
                    }

                    if(e.hasOwnProperty("position")) {
                    	this.position = e.position;
					}


                    if(e.hasOwnProperty("delay_time")) {
                        this.delay_time = parseInt(e.delay_time);
                    }

                    this.makeToast();
                }


            });
        },
        methods : {
            makeToast(append = false) {
                this.toastCount++;
                this.$bvToast.toast(this.string_err, {
                    title: this.string_title,
                    autoHideDelay: this.delay_time,
                    appendToast: true,
					toaster:this.position,
                    variant: this.variant,
                    solid:true,
                })
            }
        }
    }
</script>

<style scoped>

</style>
